import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  BadgeIndianRupee,
  CalendarDays,
  Download,
  Package,
  Target,
  Trophy,
} from "lucide-react";
import { formatEarningsCurrency } from "../earningsAdapters";
import "./CommunityGrowthIncentives.css";

const MrcCommissonDetails = () => {
  const navigate = useNavigate();
  const progress = 100;

  return (
    <section className="community-page">
      <div className="community-shell">
        <header className="community-page-header community-details-page-header">
          <div className="community-title-wrap">
            <button
              type="button"
              className="community-back-button"
              onClick={() => navigate("/MrcCommissons")}
              aria-label="Back to Community Growth Incentives"
            >
              <ArrowLeft size={20} />
            </button>
            <div>
              <span className="community-eyebrow">COMMUNITY GROWTH</span>
              <h1>Community Growth Incentive Details</h1>
              <p>
                Complete achievement, voucher, SCGR and bonus incentive
                information.
              </p>
            </div>
          </div>
          <span className="community-status community-status-completed">
            Success
          </span>
        </header>

        <div className="community-details-grid">
          <section className="community-detail-card community-detail-card-order">
            <div className="community-detail-heading">
              <CalendarDays size={20} />
              <div>
                <span>ORDER & ACHIEVEMENT</span>
                <h2>Purchase Information</h2>
              </div>
            </div>
            <div className="community-detail-kv-grid">
              <div>
                <span>Order Date</span>
                <strong>01-08-2025</strong>
                <small>12:13 pm IST</small>
              </div>
              <div>
                <span>Order ID</span>
                <strong>SA-220325-517501-CA61</strong>
              </div>
              <div>
                <span>Date</span>
                <strong>01-08-2025</strong>
                <small>12:13 pm IST</small>
              </div>
              <div>
                <span>Milestone</span>
                <strong>Milestone - 1</strong>
              </div>
              <div>
                <span>Order Type</span>
                <strong>Original</strong>
              </div>
            </div>
          </section>

          <section className="community-detail-card community-detail-product">
            <div className="community-detail-heading">
              <Package size={20} />
              <div>
                <span>PRODUCT INFORMATION</span>
                <h2>Shopping Voucher</h2>
              </div>
            </div>
            <div className="community-detail-product-row">
              <img src="../../assets/img/mobiles/mobiles-4.png" alt="" />
              <div>
                <span className="community-section-label">PRODUCT NAME</span>
                <h3>Salar Shopping Voucher</h3>
                <p>
                  Salar Code: <strong>S34O251</strong>
                </p>
                <strong className="community-detail-price">
                  {formatEarningsCurrency(22000)}
                </strong>
              </div>
            </div>
          </section>

          <section className="community-detail-card">
            <div className="community-detail-heading">
              <BadgeIndianRupee size={20} />
              <div>
                <span>RECEIVED INCENTIVES</span>
                <h2>SCGR Incentive</h2>
              </div>
            </div>
            <div className="community-incentive-highlight">
              <span>Milestone - 1</span>
              <strong>{formatEarningsCurrency(500)}</strong>
              <small>Received SCGR Incentive</small>
            </div>
          </section>

          <section className="community-detail-card">
            <div className="community-detail-heading">
              <Target size={20} />
              <div>
                <span>BONUS SCGR INCENTIVE</span>
                <h2>Target Progress</h2>
              </div>
            </div>
            <div className="community-target-grid">
              <div>
                <span>Target Days</span>
                <strong>10</strong>
              </div>
              <div>
                <span>Achieved Days</span>
                <strong>10</strong>
              </div>
            </div>
            <div className="community-progress-track">
              <span style={{ width: `${progress}%` }} />
            </div>
            <div className="community-bonus-total">
              <span>Received Bonus SCGR Incentive</span>
              <strong>{formatEarningsCurrency(500)}</strong>
            </div>
          </section>
        </div>

        <section className="community-detail-footer-card">
          <div>
            <Trophy size={20} />
            <div>
              <strong>Achievement Summary</strong>
              <span>Milestone - 1 · Community Growth</span>
            </div>
          </div>
          <button type="button">
            <Download size={17} />
            Download Payout Receipt
          </button>
        </section>
      </div>
    </section>
  );
};

export default MrcCommissonDetails;
